import React from 'react';
import { useTranslation } from 'react-i18next';

const summaryValues = ['€4.800', '€1.200', '12'];
const summaryColors = ['#22c55e', '#6366f1', '#f59e0b'];

const StripeSlide: React.FC = () => {
  const { t } = useTranslation();
  const m = t('demoTour.mockups.stripe', { returnObjects: true }) as any;
  const labels = m.summaryLabels as string[];
  const th = m.th as string[];
  const rows = m.rows as any[];

  return (
    <div className="dt-mockup-stripe">
      <div className="dt-stripe-toolbar">
        <span className="dt-stripe-toolbar-title">{m.toolbarTitle}</span>
        <span className="dt-stripe-toolbar-badge">{m.toolbarBadge}</span>
      </div>
      <div className="dt-invoice-summary">
        {labels.map((label: string, i: number) => (
          <div key={label} className="dt-invoice-summary-card">
            <div className="dt-invoice-summary-value" style={{ color: summaryColors[i] }}>{summaryValues[i]}</div>
            <div className="dt-invoice-summary-label">{label}</div>
          </div>
        ))}
      </div>
      <div className="dt-invoice-table">
        <div className="dt-invoice-table-head dt-stripe-table-head">
          {th.map((h: string) => <span key={h}>{h}</span>)}
        </div>
        {rows.map((r: any, i: number) => (
          <div key={i} className="dt-invoice-table-row dt-stripe-table-row">
            <span>{r.client}</span>
            <span className="dt-stripe-product">{r.product}</span>
            <span>{r.amount}</span>
            <span className={`dt-invoice-status dt-invoice-status--${r.statusClass}`}>{r.status}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StripeSlide;
